import { BackgroundProp, DesignProp } from "../PropCategories";

export const backgroundSize = {
  prop: "style-attribute",
  name: "Background size",
  nameI18n: "builder_ui.prop_type.styles.background_size",
  category: [DesignProp, BackgroundProp],
  type: "select",
  defaultValue: "cover",
  options: [
    {
      label: "Cover",
      labelI18n: "builder_ui.prop_type.styles.background_size_types.cover",
      value: "cover",
    },
    {
      label: "Contain",
      labelI18n: "builder_ui.prop_type.styles.background_size_types.contain",
      value: "contain",
    },
    {
      label: "Auto",
      labelI18n: "builder_ui.prop_type.styles.background_size_types.auto",
      value: "auto",
    },
    {
      label: "100%",
      labelI18n: "builder_ui.prop_type.styles.background_size_types.full",
      value: "100% 100%",
    },
  ],
} as const;
